const footerLinks = [
  {
    title: '热门导航',
    links: [
      { label: '最新电视剧', href: '#index' },
      { label: '高清电影', href: '#carousel' },
      { label: '热门话题', href: '#topics' },
      { label: '热度榜单', href: '#ranking' },
    ],
  },
  {
    title: '关于我们',
    links: [
      { label: '平台介绍', href: '#about' },
      { label: '常见问题', href: '#faq' },
      { label: '投稿合作', href: '#contact' },
      { label: '最新动态', href: '#updates' },
    ],
  },
  {
    title: '观影指南',
    links: [
      { label: '平台优势', href: '#features' },
      { label: '用户评价', href: '#comments' },
      { label: '精彩花絮', href: '#media' },
      { label: '移动观影', href: '#app' },
    ],
  },
];

export default function Footer() {
  const handleClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer id="footer" className="bg-background-900 text-background-100">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500">
                  <i className="ri-movie-2-line text-background-50 text-lg"></i>
                </span>
                <span className="text-lg font-bold text-background-50 font-heading">
                  木瓜影视
                </span>
              </div>
              <p className="text-sm text-background-400 leading-relaxed">
                高清不缓冲在线观看平台，免费无广告极速播放，最新电视剧电影高清免费在线看，畅享流畅观影体验。
              </p>
            </div>

            {footerLinks.map((group) => (
              <div key={group.title}>
                <h4 className="text-sm font-semibold text-background-50 mb-4 font-heading">
                  {group.title}
                </h4>
                <ul className="space-y-2.5">
                  {group.links.map((link) => (
                    <li key={link.label}>
                      <a
                        href={link.href}
                        onClick={(e) => { e.preventDefault(); handleClick(link.href); }}
                        className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                      >
                        {link.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="mt-10 pt-8 border-t border-background-700/50">
            <h4 className="text-sm font-semibold text-background-400 mb-3 font-heading">合作伙伴</h4>
            <p className="text-xs text-background-600">更多合作伙伴即将入驻，敬请期待</p>
          </div>

          <div className="mt-8 pt-6 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-600">
              &copy; 2026 木瓜影视 版权所有 | 高清不缓冲在线观看不卡顿
            </p>
            <div className="flex items-center gap-4">
              <span className="text-xs text-background-600 cursor-pointer hover:text-background-400 transition-colors">
                服务条款
              </span>
              <span className="text-xs text-background-600 cursor-pointer hover:text-background-400 transition-colors">
                隐私政策
              </span>
              <span className="text-xs text-background-600 cursor-pointer hover:text-background-400 transition-colors">
                免责声明
              </span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}